module.exports = __webpack_public_path__ + "static/derek-fe58705098574ca945405db7df5a7542.jpg";